<template>
    <div :class="!$vuetify.display.mobile ? '' : 'fill-height'">
        <template v-if="isStatic">
            <DocumentStatic
                v-if="!$vuetify.display.mobile"
                :mode="mode"
                :companyId="companyId"
                :inDocument="document"
                :previousIdIsset="previousIdIsset"
                :nextIdIsset="nextIdIsset"
                :is-accounting-item="isAccountingItem"
                :key="`DocumentStatic_${id}`"
                @task-ended="onTaskEnded"
                @previous="previous"
                @next="next"
                @back="back"
                @edit="onEdit"
                @deleted="deleted"
                @openReconciliation="openReconciliation"
                @updating="onUpdating"
            />
            <DocumentStaticMobile
                v-else
                :mode="mode"
                :companyId="companyId"
                :inDocument="document"
                :previousIdIsset="previousIdIsset"
                :nextIdIsset="nextIdIsset"
                :is-accounting-item="isAccountingItem"
                :key="`DocumentStaticMobile_${id}`"
                @task-ended="onTaskEnded"
                @previous="previous"
                @next="next"
                @back="back"
                @edit="onEdit"
                @openReconciliation="openReconciliation"
                @updating="onUpdating"
            />
        </template>
        <DocumentChat
            v-else-if="isChat"
            :mode="mode"
            :companyId="companyId"
            :inDocument="document"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @task-ended="onTaskEnded"
            @previous="previous"
            @next="next"
            @openReconciliation="openReconciliation"
            @updating="onUpdating"
            :key="`DocumentChat_${id}`"
        />
        <DocumentToReupload
            v-else-if="toReupload"
            :mode="mode"
            :companyId="companyId"
            :inDocument="document"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @task-ended="onTaskEnded"
            @previous="previous"
            @next="next"
            @openReconciliation="openReconciliation"
            :key="`DocumentToReupload_${id}`"
        />
        <DocumentValidation
            v-else-if="
                toValidate && !$vuetify.display.mobile && selectedCompany.solution !== 'MANAGEMENT'
            "
            :mode="mode"
            :companyId="companyId"
            :inDocument="document"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @task-ended="onTaskEnded"
            @previous="previous"
            @next="next"
            @openReconciliation="openReconciliation"
            @back="back"
            @updating="onUpdating"
            :key="`DocumentValidation_${id}`"
        />
        <DocumentValidationManagement
            v-else-if="
                toValidate && !$vuetify.display.mobile && selectedCompany.solution === 'MANAGEMENT'
            "
            :mode="mode"
            :companyId="companyId"
            :inDocument="document"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @task-ended="onTaskEnded"
            @previous="previous"
            @next="next"
            @openReconciliation="openReconciliation"
            @updating="onUpdating"
            :key="`DocumentValidationManagement_${id}`"
        />
        <DocumentValidationMobile
            v-else-if="toValidate && document.status === 'ANALYSED' && $vuetify.display.mobile"
            :mode="mode"
            :companyId="companyId"
            :inDocument="document"
            :previousIdIsset="previousIdIsset"
            :nextIdIsset="nextIdIsset"
            @task-ended="onTaskEnded"
            @previous="previous"
            @next="next"
            @back="back"
            @openReconciliation="openReconciliation"
            @updating="onUpdating"
            :key="`DocumentValidationMobile_${id}`"
        />
        <oss-dialog
            v-model="beforeRouteLeaveDialog"
            title="Enregistrer ?"
            @valid="
                routeNext();
                beforeRouteLeaveDialog = false;
            "
            :validTitle="'Oui je suis sûr(e)'"
            @close="
                routeNext(false);
                beforeRouteLeaveDialog = false;
            "
            width="800px"
        >
            <h4 class="text-center">
                Les modifications que vous avez apportées ne seront peut-être pas enregistrées.
                &#xca;tes vous sûr(e) de vouloir changer de page ?
            </h4>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import _ from "lodash";

import DocumentStatic from "./DocumentStatic.vue";
import DocumentValidation from "./DocumentValidation.vue";
import DocumentValidationManagement from "./DocumentValidationManagement.vue";
import DocumentValidationMobile from "./DocumentValidationMobile.vue";
import DocumentValidationPaySlip from "./DocumentValidationPaySlip.vue";
import DocumentValidationPaySlipStatic from "./DocumentValidationPaySlipStatic.vue";
import DocumentChat from "./DocumentChat.vue";

import { Component, toNative } from "vue-facing-decorator";
import { DocumentRouterBase } from "./DocumentRouterBase";

@Component({
    components: {
        DocumentStatic,
        DocumentValidation,
        DocumentValidationManagement,
        DocumentValidationMobile,
        DocumentValidationPaySlip,
        DocumentValidationPaySlipStatic,
        DocumentChat,
    },
})
export class DocumentRouterInExpenseReport extends DocumentRouterBase {}

export default toNative(DocumentRouterInExpenseReport);
</script>
